class FablairBackTop extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const button = this.querySelector('button');
    if (!button) return;
    const update = () => button.toggleAttribute('data-visible', window.scrollY > 600);
    window.addEventListener('scroll', update, { passive: true, signal });
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      const target = document.querySelector('.rs-header__brand, .header-logo');
      target?.focus({ preventScroll: true });
    }, { signal });
    update();
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('fablair-back-top')) customElements.define('fablair-back-top', FablairBackTop);
